// user authentication module
export const SIGN_IN_MODULE = "SIGN_IN_MODULE";
export const SIGN_UP_MODULE = "SIGN_UP_MODULE";
export const FORGOT_PASSWORD_MODULE = "FORGOT_PASSWORD_MODULE";

export const SIGN_IN_LANDING_PAGE = "SIGN_IN_LANDING_PAGE";
export const SIGN_IN_OTP_PAGE = "SIGN_IN_OTP_PAGE";
export const SIGN_IN_WITH_PASSWORD_PAGE = "SIGN_IN_WITH_PASSWORD_PAGE";

export const FORGOT_PASSWORD_LANDING_PAGE = "FORGOT_PASSWORD_LANDING_PAGE";
export const FORGOT_PASSWORD_OTP_PAGE = "FORGOT_PASSWORD_OTP_PAGE";
export const FORGOT_PASSWORD_RESET_PAGE = "FORGOT_PASSWORD_RESET_PAGE";

export const SIGN_UP_LANDING_PAGE = "SIGN_UP_LANDING_PAGE";
export const SIGN_UP_OTP_PAGE = "SIGN_UP_OTP_PAGE";
export const SIGN_UP_WITH_PASSWORD_PAGE = "SIGN_UP_WITH_PASSWORD_PAGE";
export const BOOKING_IS_ETIHAD_BOOKING = "BOOKING_IS_ETIHAD_BOOKING";

export const SUCCESS_AUTH = "SUCCESS_AUTH";

export const SIGN_UP_SUCCESS_PAGE_URL = "/successpage?module=signup";
export const LOGIN_SUCCESS_PAGE_URL = "/successpage?module=login";
export const RESET_PASSWORD_SUCCESS_PAGE_URL = "/successpage?module=login";

export const DEBOUNCE_DELAY = 500;
export const MINIMUM_DEBOUNCE_DELAY = 200;
export const ANIMATION_DELAY = 2000;
export const ANIMATION_END_DELAY = 5000;

export const FEEDBACK_MAX_CHARS = 1000;
export const FEEDBACK_MIN_CHARS = 10;
export const REDIRECT_DELAY = 2000;
export const WHEELCHAIR_SSRCODE = "WCHR";
export const SEAT_SELECTION_SSRCODE = "SFE";
export const PRIORITY_BAGGAGE_SSRCODE = "PRIO";
export const PRIORITY_BOARDING_SSRCODE = "PRBD";
export const DELAY_COVER_SSRCODE = "FLDL";
export const CANCEL_COVER_SSRCODE = "XPRO";
export const LOUNGE_SSRCODE = "ALNG";
export const TRAVEL_INSURANCE_SSRCODE = "INSU";
export const DELAY_AND_LOST_BAGGAGE_SSRCODE = "DLBG";
export const CONVENIENCE_FEE_CODE = "WFE";
export const DELAY_FARE = "delayFare";
export const CANCEL_FARE = "cancelFare";
export const LOUNGE_FARE = "loungeFare";
export const TRAVEL_FARE = "travelFare";
export const BAGGAGE_FARE = "baggageFare";
export const PRIORITY_FARE = "priorityFare";
export const LOST_BAGGAGE_FARE = "lostBaggageFare";
export const PRIORITY_BOARDING_FARE = "priorityBoardFare";

export const SEAT_PLUS_MEAL_FEE_CODE = "AKVL";

export const ADDONS_CMS_TITLE = "Small cards";
export const MEALS_TITLE = "Café Akasa";
export const MEALS_MEAL_CODE = "MEAL";
export const EXCESS_BAGGAGE_TITLE = "Excess baggage";
export const EXCESS_BAGGAGE_CODE = "XSBG";
export const PRIORITY_BAGGAGE_TITLE = "Priority Check-in & Bag";
export const PRIORITY_BAGGAGE_CODE = "PCNB";
export const EXTRA_SEAT_CODE = "EXST";
export const FLIGHT_DELAY_TITLE = "Flight delay cover";
export const FLIGHT_DELAY_CODE = "";
export const CANCEL_COVER_TITLE = "Flexi cover";
export const LOUNGE_TITLE = "Lounge";
export const TRAVEL_TITLE = "Trip Cover";
export const PRIORITY_BOARD_TITLE = "Board First";
export const PRIORITY_BOARD_CODE = "BFST";
export const COUNTRIES = ["India", "United Kingdom", "Dubai", "USA"];
export const GENDER = ["Male", "Female"];
export const BOOKING_GROUP_TYPE = [
  "Wedding",
  "Corporate",
  "Events",
  "Meeting",
  "Conference/Convention",
  "Leisure Travel"
];

export const ADD_ON_DEEPLINK = {
  CAFE_AKASA: "cafeAkasa",
  EXCESS_BAGGAGE: "ExcessBaggage",
  SEAT_MEAL_DEAL: "Seat&MealDeal",
  PRIORITY_CHECK_IN: "PriorityCheckInBag",
  BOARD_FIRST: "BoardFirst",
  LOUNGE_ADDON: "Lounge",
  TRIP_COVER: "TripCover",
  DELAYED_LOST_BAGGAGE : "DelayedOrLostBaggage",
  FLIGHT_DELAY_COVER : "FlightDelayCover"
};

export const BOOKING_TYPE = {
  ONE_WAY: "ONE_WAY",
  ROUND_TRIP: "ROUND_TRIP",
  MULTI_CITY: "MULTI_CITY"
};

export const BOOKING_CLASS = {
  NORMAL_BOOKING: "NORMAL_BOOKING",
  GROUP_BOOKING: "GROUP_BOOKING",
};

export const FLIGHT_STATUS_DEEPLINK = {
  FLIGHT_NUMBER: "flightNumber",
  PNR_FORM: "PNR"
};

export const PASSENGER_TYPE = {
  ADULT: "ADT",
  CHILD: "CHD",
  INFANT: "INF",
  EXTRA_SEAT: "EXST",
  SENIOR_CITIZEN: "SNR",
  STUDENT: "STU",
  MEDICAL: "MED",
  ARMED_FORCE: "DEF",
  MINOR: "UMNR"
};

export const NOT_ALLOWED_SSRS_LIST = ["TCER"];
export const FEE_CODES = [TRAVEL_INSURANCE_SSRCODE, DELAY_AND_LOST_BAGGAGE_SSRCODE];
export const PASSENGER_TYPE_NAME = {
  ADT: "Adult",
  CHD: "Child",
  INF: "Infant",
  EXST: "Extra Seat",
  SNR: "Senior Citizen",
  STU: "Student",
  MED: "Medical Professionals",
  DEF: "Armed Forces"
};
export const PRODUCT_CLASSES = ["EC", "AV"];
export const FARE_TYPES = ["R", "V"];
export const PRODUCT_CLASSES_NAME = {
  EC: "Saver",
  AV: "Flexi"
};
export const PRODUCT_CLASS_MAP = {
  AKASA_STD: "EC",
  AKASA_VALUE: "AV"
};

export const BUNDLE_CODE = {
  PLUS: "PLUS",
  CRPX: "CRPX",
  SEAT_PLUS_MEAL: "PPUS",
  PREMIUM: "AKPR"
};

export const PRODUCT_CLASS_PREMIUM_NAME = "EC";
export const DEFAULT_NVTR_COUNTRY_CODE = "IN";
export const DEFAULT_CURRENCY_CODE = "INR";
export const NOTIFICATION_MESSAGE_TYPE = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning"
};
export const STATUS = {
  CONFIRMED: "Confirmed",
  CLOSED: "Closed",
  HOLD: "Hold"
};

export const LIFT_STATUS = {
  DEFAULT: "Default",
  CHECKEDIN: "CheckedIn",
  BOARDED: "Boarded",
  NO_SHOW:"NoShow"
};

export const ACCOUNTTRANSACTIONCODE = "CXL";

export const SEAT_TYPE = {
  WINDOW: "Window",
  AISLE: "Aisle"
};

export const SPECIAL_FARE_TYPE_TEXT = {
  STUDENT: "Student",
  ARMED_FORCE: "Armed Forces",
  MEDICAL_PROFESSIONALS: "Medical Professionals",
  UNACCOMPANIED_MINOR: "Unaccompanied Minor",
  SENIOR_CITIZEN: "Senior Citizen"
};
export const UMNR_CODE = "UMNR";
export const ONEWAY_CHECKIN = "Your one way flight";
export const FLIGHT_LEG_STATUS = "SCHEDULED";
export const ROUNDTRIP_CHECKIN = "Your round trip flights";
export const MULTICITY_CHECKIN = "Your multi city flights";
export const PNR = "PNR";
export const PASSENGERS = " Passengers";
export const PASSENGER = " Passenger";
export const CHECKINBTN = "Check-in";
export const CHANGEBOOKINGBTN = "Change Date";
export const GATE = "Gate";
export const BOOKING_STATUS = "Booking status";
export const FLIGHT_DETAILS = "Flight details";
export const CHECK_IN_FOR = "Check-in for";
export const PASSENGER_NAME = "Passenger name";
export const SELECT_ALL = "Select all";
export const CHECKIN_OPENS_48_HOURS_PRIOR = "Check-in opens 48 hours prior";
export const CHECKEDIN = "Checked-in";
export const CONDITIONS_BEFORE_YOU_FLY = "Conditions before you fly";
export const DEFAULT_COUNTRY_CODE = "+91";
export const DATE_FORMAT = "DD MMM YYYY";
export const MOBILE_DEVICE_TYPE = "mobile_app";
export const NEWS_CARDS_LOAD_SIZE = 9;
export const ALL = "all";
export const NO_ERROR = "NO_ERROR";
export const ADULT_ERROR = "ADULT_ERROR";
export const SENIOR_CITIZEN_ERROR = "SENIOR_CITIZEN_ERROR";
export const CHILDREN_ERROR = "CHILDREN_ERROR";
export const INFANT_ERROR = "INFANT_ERROR";
export const EXTRA_SEAT_ERROR = "EXTRA_SEAT_ERROR";
export const TOTAL_ERROR = "TOTAL_ERROR";
export const INFANTS_EXCEEDED_ADULTS = "INFANTS_EXCEEDED_ADULTS";
export const NEWSLETTER_SUBSCRIBE_SUCCESS_RESET_TIME = 5000;
export const CANCEL_BOOKING_FEE_CODE = "CXL";
export const YEARS = ["2022"];
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const ALLOW_SPECIAL_FARE = ["DEF", "MED", "STU", "UMNR", "SNR"];
export const SPECIAL_ASSISTANCE_SSR = ["WCHC", "WCHR", "WCHS", "BLND"];
export const CAROUSEL_TRANSITION_DELAY = 5000; // milliseconds
export const CAROUSEL_TRANSITION_TIMING = 1500; // milliseconds

export const CONVENIENCE_FEE_AMOUNT = 0;

// payment type
export const PAYMENT_NEW_BOOKING = "NEW_BOOKING";
export const PAYMENT_CHANGE_FLIGHT = "CHANGE_FLIGHT";
export const ADD_ON_OR_SEAT_PURCHASE = "ADD_ON_OR_SEAT_PURCHASE";
export const TRAVEL_CERTIFICATE = "TRAVEL_CERTIFICATE";
export const ERROR_API_NAME = {
  CURRENT_BOOKING_IN_STATE: "CURRENT_BOOKING_IN_STATE",
  CANCELLED_BOOKING_IN_STATE: "CANCELLED_BOOKING_IN_STATE",
  FLIGHT_AVALIABLE: "FLIGHT_AVALIABLE",
  CHECKIN: "CHECKIN",
  MEAL_CATEGORIES: "MEAL_CATEGORIES",
  SSR_SELL_API: "SSR_SELL_API",
  VOUCHER_API: "VOUCHER_API",
  LOW_FARE_CALENDER: "LOW_FARE_CALENDER"
};

export const OTP_MAX_LENGTH = 6;
export const RESEND_OTP_TIMING = 30;
export const MAX_ALLOW_WEIGHT = 60;

export const MEAL_BOOKING_HOUR_LIMIT = 12;
export const GENDER_CODE = ["M", "F"];
export const DATELIST = ["Yesterday", "Today", "Tomorrow", "Day After"];

export const FLOW_TYPE = {
  MANAGE_BOOKING: "MANAGE_BOOKING",
  NEW_BOOKING: "NEW_BOOKING",
  CHECK_IN: "CHECK_IN",
  CHECKIN_BOOKING: "CHECKIN_BOOKING",
  MY_BOOKINGS: "MY_BOOKINGS",
  TRAVEL_CERTIFICATE: "TRAVEL_CERTIFICATE",
  CHANGE_BOOKING: "CHANGE_BOOKING",
};

// adt limit is from 1 to 9
export const TOTAL_PAX_COUNT_LIMIT = 9;
export const UNACCOMPANIED_MINOR_LIMIT = 4;
export const INFANT_UPPER_LIMIT = 4;
export const ZERO_VALUE = 0;
export const MIN_PAX_VALUE = 1;
export const PNR_LEVEL_SSR_CODES = [TRAVEL_INSURANCE_SSRCODE, DELAY_AND_LOST_BAGGAGE_SSRCODE, BUNDLE_CODE.SEAT_PLUS_MEAL];
export const SEGMENT_LEVEL_SSR_CODES = [
  "XC03",
  "XC05",
  "XC10",
  "XC15",
  "XC20",
  "XC30",
  "ABAG",
  "2BAG",
  "1KIT",
  "2KIT",
  "PRIO",
  "PRBD",
  "WCHS",
  "WCHC",
  "WCHR",
  CANCEL_COVER_SSRCODE,
  TRAVEL_INSURANCE_SSRCODE
];

export const JOURNEY_LEVEL_SSR_CODES = [
  "PRIO",
  "PRBD"
];

export const DEMOSTIC_EXCESS_BAGGAGE = [
  { ssrCode: "XC03", name: "3  Kgs", unit: 3 },
  { ssrCode: "XC05", name: "5 Kgs", unit: 5 },
  { ssrCode: "XC10", name: "10 Kgs", unit: 10 },
  { ssrCode: "XC15", name: "15 Kgs", unit: 15 },
  { ssrCode: "XC20", name: "20 Kgs", unit: 20 },
  { ssrCode: "XC30", name: "30kg", unit: 30 }
];
export const DEMOSTIC_EXCESS_BAGGAGE_KEY = ["XC03", "XC05", "XC10", "XC15", "XC20", "XC30"];
export const INTERNATION_EXCESS_BAGGAGE = [
  { ssrCode: "IN08", name: "8  Kgs", unit: 8 },
  { ssrCode: "IN10", name: "10 Kgs", unit: 10 },
  { ssrCode: "IN15", name: "15 Kgs", unit: 15 },
  { ssrCode: "IN30", name: "30kg", unit: 30 }
];
export const INTERNATION_EXCESS_BAGGAGE_KEY = ["IN08", "IN10", "IN15", "IN30"];
export const EXTRA_BAGGAGE_KEY = ["ABAG", "2BAG"];
export const MUSIC_KIT_BAGGAGE_KEY = ["1KIT", "2KIT"];

export const ALL_BAGGAGE_SSRCODES = [...DEMOSTIC_EXCESS_BAGGAGE_KEY, ...INTERNATION_EXCESS_BAGGAGE_KEY, ...EXTRA_BAGGAGE_KEY, ...MUSIC_KIT_BAGGAGE_KEY];

export const AGE_FOR_ADULT = 12; // in years
export const AGE_FOR_SENIOR_CITIZEN = 60; // in years
export const AGE_FOR_INFANT = 730; // in days
export const DATE_AND_TIME_FORMATS = {
  DAY_DATE_MONTH: "ddd, DD MMM",
  DATE_MONTH: "DD MMM",
  DATE_ONLY: "DD",
  MMM_YY: "MMM‘YY",
  TWELVE_HOUR_FORMAT: "HH:MM",
  SHORT_MONTH: "MMM",
  DD_MMM_YYYY: "DD MMM YYYY",
  DD_MM_YY: "DDMMYYY",
  YYYY_MM_DD: "YYYY-MM-DD",
  MMMM_YYYY: "MMMM yyyy",
  YYYY_MM_DD_DATE_FNS: "yyyy-MM-dd",
  DAY_DATE_MONTH_YEAR: "ddd, DD MMM YYYY",
  D_MMM_YYYY: "D MMM, YYYY",
  DDD_DO_MMM: "ddd, Do MMM",
  YYYY_MM_DD_THH_MM: "YYYY-MM-DDTHH:mm",
  DDD_MMM_DD_YYYY_HHMM_SS: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ",
  YEAR_MONTH_DATE: "YYYY/MM/DD",
  DATE_MONTH_YEAR: "DD/MM/YYYY",
  YEAR_MONTH_DATE_FORMAT: "yyyy/MM/dd",
  MM_YY: "MMM YY",
  DD_MMM_YY: "DD MMM YY",
  YYYY: "YYYY",
  DD_MM_YYYY: "DD/MM/YYYY",
  MONTH_ONLY: "MMM"
};
export const GENDER_TYPE = {
  MALE: "Male",
  FEMALE: "Female"
};

export const AFFILIATE_STAGE = {
  HOME_PAGE: "HOME_PAGE",
  DAYVIEW_PAGE: "DAYVIEW_PAGE",
  BOOKING_PAGE: "BOOKING_PAGE"
};

export const MALE_CATERGORIES = ["father", "brother", "husband", "son"];
export const FEMALE_CATERGORIES = ["mother", "sister", "wife", "daughter"];
export const UNDO_CHECK_IN_DEFAULT_TIME = 75;
export const TRIPCOVERRETURNTRIPDAYSlIMIT = 30;

export const DATE_STRAP_INCREMENT_AND_DECREMENT = 10;
export const UNDO_CHECK_IN_RESEND_OTP_TIMING = 180;
export const CANCEL_BOOKING_RESEND_OTP_TIMING = 180;
export const INSURANCE_SSR_CODES = ["INSU", "XPRO", "FLDL"];
export const DEFAULT_MANAGE_BOOKING_RESTRICTIONS = {
  allowChangeDate: true,
  allowUndoCheckIn: true,
  allowCancelBooking: true,
  allowEmailItinerary: true,
  allowUpdateContact: true,
  allowAddOns: true,
  allowViewGst: true,
  allowCheckIn: true
};

export const BOOKING_TYPES_LIST = [
  {
    type: BOOKING_TYPE.ONE_WAY,
    title: "oneWay"
  },
  {
    type: BOOKING_TYPE.ROUND_TRIP,
    title: "roundTrip"
  }
];

export const MANAGE_BOOKING_TABS = ["upcoming", "past"];
export const PROMO_CODE_MIN_LENGTH_HOME_PAGE = 5;
export const PROMO_CODE_MIN_LENGTH = 5;
export const PROMO_CODE_MAX_LENGTH = 8;

export const WEB = "WEB";
export const DIAL_CODE ={
  INDIA: "+91"
}

export const CHARGES_DATE_CANCELLATION = {
  date: "Date Change Charges",
  cancellation: "Cancellation Charges"
};
export const REFUND_STATUS_VALUES = {
  INITIATED: "INITIATED",
  PROCESSING: "PROCESSING",
  WITH_BANK: "WITH_BANK",
  SETTLED: "SETTLED"
}
export const FLIGHT_STATUS_VALUES = {
  ARRIVED : "ARRIVED",
  NOT_DEPARTED : "NOT_DEPARTED",
  DEPARTED : "DEPARTED",
  EARLY: "EARLY",
  ARRIVED_LATE: "ARRIVED_LATE",
  ARRIVED_EARLY: "ARRIVED_EARLY",
  DELAYED: "DELAYED",
  YET_TO_DEPART: "YETTODEPART",
  ONTIME: "ONTIME",
  CANCELLED: "CANCELLED"
}
export const CAFE_AKASA = "Café Akasa";
export const SEAT_SELECTION = " Select Your Seat";
export const CURRENT_ACTIVE_PROMOCODES = ["AKASA1", "APPLOVE"];
export const CONNECTING_FLIGHT_TYPE = "Connect";

export const OTP_SEND_LIMIT = 15;
export const MINIMUM_PASSWORD_LENGTH = 8; // in Charas
export const MAXMIUM_PASSWORD_LENGTH = 128; // in Charas

export const TYPE_OF_FLOW_IN_GROUP = {
  CHECK_IN: "checkin",
  MY_BOOKING: "myBooking",
} 

export const BOOKING_MODE = {
  IS_GROUP_BOOKING: "BOOKING_IS_GROUP_BOOKING",
  IS_NOT_GROUP_BOOKING: "BOOKING_IS_NOT_A_GROUP_BOOKING",
};

export const VOUCHERS_CODES = {
  VOUCHER_FETCH_EXCEPTION: "VOUCHER_FETCH_EXCEPTION",
  VOUCHER_REDEEM_EXCEPTION: "VOUCHER_REDEEM_EXCEPTION",
  PASSENGER_NOT_FOUND_EXCEPTION: "PASSENGER_NOT_FOUND_EXCEPTION",
  ALREADY_USED_VOUCHER_FOR_SAME_PNR_EXCEPTION: "ALREADY_USED_VOUCHER_FOR_SAME_PNR_EXCEPTION",
  VOUCHER_EXPIRED_EXCEPTION: "VOUCHER_EXPIRED_EXCEPTION",
  VOUCHER_CLASS_OF_SERVICE_EXCEPTION: "VOUCHER_CLASS_OF_SERVICE_EXCEPTION",
  MAX_VOUCHERS_EXCEPTION: "MAX_VOUCHERS_EXCEPTION",  
  NO_BALANCE_DUE_FOR_PAX: "NO_BALANCE_DUE_FOR_PAX"
};

export const ORDER_API_STATUS_CODE = {
  EXECUTED: "EXECUTED",
  CREATED: "CREATED",
  FAILED: "FAILED",
  BOOKING_ORDER_AMOUNT_OVERPAID: "BOOKING_ORDER_AMOUNT_OVERPAID"
};

export const WHEEL_CHAIR_SSR_KEYS = ["WCHR", "WCHS", "WCHC"];
